import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import Index from './Index';
import Inbox from './Inbox';
import Sent from './Sent';

const Main = () => {
  const [messageCount, setMessageCount] = React.useState(null);
  return (
    <div>
      <Routes>
        <Route path="/" element={<Index messageCount={messageCount} />}>
          <Route index element={<Navigate to="inbox" />} />
          <Route path="sent" element={<Sent />} />
          <Route path="inbox" element={<Inbox setMessageCount={setMessageCount} />} />
        </Route>
      </Routes>
    </div>
  );
};

export default Main;
